module.exports = __webpack_public_path__ + "static/regualtorisches-0c74f3824c5c2b2c615f277dcd4c3f66.png";